import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, tap, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { ToastService } from 'src/app/toast/toast.service';
import { User, EditUser, NewUser, SimpleUser } from './user';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private userUrl = environment.apiUrl + 'Users'; // URL to web api

  constructor(private http: HttpClient, public toastService: ToastService) {}

  public getUsers() {
    const url = `${this.userUrl}`;
    return this.http.get<User[]>(url);
  }

  public updateUser(user: EditUser) {
    const url = `${environment.apiUrl}Users`;
    return this.http.put<User>(url, user);
  }

  public addUser(newUser: NewUser) {
    const url = `${environment.apiUrl}Users`;
    return this.http.post<User>(url, newUser);
  }

  public deactivateUser(id: string) {
    const url = `${environment.apiUrl}Users/${id}/Deactivate`;
    return this.http.put<User>(url, {});
  }

  public getUsersByFirstName(searchTerm: string) {

    const url = `${environment.apiUrl}Users/ByFirstName/${searchTerm}`;
    return this.http.get<User[]>(url);
  }

  public getUsersByLastName(searchTerm: string) {
    const url = `${environment.apiUrl}Users/ByLastName/${searchTerm}`;
    return this.http.get<User[]>(url);
  }

  public getUsersByEmail(searchTerm: string) {
    const url = `${environment.apiUrl}Users/ByEmail/${searchTerm}`;
    return this.http.get<User[]>(url);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.toastService.addMessage({ text: `${error.message}`, error: true });
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
